import { IActTeamStore } from './types';

const initStore: IActTeamStore = {
  current: null,
  list: [],
  availableActTeams: [],
  allActTeams: [],
  pagination: {
    pageSize: 25,
    pageNumber: 1,
    total: 0,
  },
};

export default initStore;
